import { useDispatch } from 'react-redux'

import { store } from 'app'

export type AppDispatchType = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatchType>()
